import { render, staticRenderFns } from "./Products_SidebarContent.vue?vue&type=template&id=6aed790f&scoped=true&"
import script from "./Products_SidebarContent.vue?vue&type=script&lang=js&"
export * from "./Products_SidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./Products_SidebarContent.vue?vue&type=style&index=0&id=6aed790f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed790f",
  null
  
)

export default component.exports